import { Title, useTranslate } from 'react-admin';
import { dataProvider } from '@src/dataProvider';
import { dataObject } from '@src/object.type';
import { FileUpload } from '@components/FileUpload';
import { entityResource as ent } from '@src/entityResource';
import { toInt, toDec } from '@src/helpers/numeric.ext';
import { sanitizeUpper } from '@helpers/string.ext';

const headers = [
    //'alasan_gagal',
    'data_kode_barang',
    'data_nama_barang',
    'data_harga_beli',
    'data_harga_jual',
    'data_stok',
    //'data_barang_jasa',
    //'data_show_toko',
    //'minimum_stok',
    //'diskon',
    //'berat_dan_satuan',
    //'berat',
    //'letak_rak',
    //'keterangan',
    'kategori',
    //'gambar',
];

export const GoodsUpload = () => {
    const translate = useTranslate();
    const verifyData = async (data: dataObject[]) => {
        const normalizedData = data
            .filter((row: dataObject) => {
                // Check if at least one field has a value
                return (
                    row.data_kode_barang ||
                    row.data_nama_barang ||
                    row.data_harga_beli ||
                    row.data_harga_jual ||
                    row.data_stok ||
                    row.kategori
                );
            })
            .map((row: dataObject) => row);

        const goodsNames = normalizedData.map(
            (d: dataObject) => d.data_nama_barang
        );

        const existingGoods = await dataProvider.getMany(ent.GOODS.NAME, {
            ids: goodsNames,
            meta: { column: 'name', page: 1, perPage: goodsNames.length + 1 },
        });

        // Filter out normalizedData items that have matching data_kode_barang in existingGoods.data
        const filteredData = normalizedData.filter((src: dataObject) => {
            return !existingGoods.data.some((goods: dataObject) => {
                return (
                    sanitizeUpper(String(src.data_kode_barang)) ===
                        sanitizeUpper(String(goods.code)) &&
                    sanitizeUpper(String(src.data_nama_barang)) ===
                        sanitizeUpper(String(goods.name)) &&
                    sanitizeUpper(String(src.kategori)) ===
                        sanitizeUpper(String(goods.category)) &&
                    toDec(String(src.data_harga_beli)) ===
                        toDec(String(goods.purchasePrice)) &&
                    toDec(String(src.data_harga_jual)) ===
                        toDec(String(goods.sellingPrice)) &&
                    //@ts-expect-error, returned value from API for goods.stock is already a number
                    toInt(src.data_stok) === goods.stock
                );
            });
        });

        return filteredData.map((d: dataObject) => {
            const {
                data_kode_barang,
                data_nama_barang,
                data_harga_beli,
                data_harga_jual,
                data_stok,
                kategori,
            } = d;
            return {
                ...(data_kode_barang && { code: data_kode_barang }),
                ...(data_nama_barang && { name: data_nama_barang }),
                ...(data_harga_beli && { purchasePrice: data_harga_beli }),
                ...(data_harga_jual && { sellingPrice: data_harga_jual }),
                ...(data_stok && { stock: data_stok }),
                ...(kategori && { category: kategori }),
            };
        });
    };

    return (
        <>
            <Title title={translate('resources.goods.action.upload')} />
            <FileUpload
                headers={headers}
                fileInputLabel={translate('resources.goods.action.upload')}
                api={ent.GOODS.UPLOAD_API}
                resource={ent.GOODS.NAME}
                verifyData={verifyData}
            />
        </>
    );
};
